module.exports = __webpack_public_path__ + "static/media/tidy_up.39bdb5c0.png";